import { ICart } from "../classes/interfaces";

const CART_KEY = "@menuchef/cart";

function defaultCart(): ICart {
  return {
    grouping_last: 0,
    product_last: 0,
    products: [],
    payments: [],
    total: 0,
    styleSale: "menu",
    channel: "menu",
  };
}

/**
 * Canal de origem do carrinho (`/store` vs `/menu`).
 *
 * Carrinhos gravados antes da separação `channel`/`styleSale` guardavam o canal
 * dentro de `styleSale`; um carrinho já em sessionStorage no momento do deploy
 * cairia aqui sem `channel`, então o valor antigo ainda é lido como fallback.
 */
export function getCartChannel(cart: Pick<ICart, "channel" | "styleSale">): "store" | "menu" {
  if (cart.channel) return cart.channel;
  return cart.styleSale === "menu" ? "menu" : "store";
}

/**
 * Esvazia os itens PRESERVANDO o contexto da sessão: o canal de origem
 * (`/store` vs `/menu`) e a configuração de venda da loja.
 *
 * "Limpar Carrinho" caía no `defaultCart()`, cujo canal é `menu`, e a partir daí
 * o "Adicionar itens" mandava para `/menu` um cliente que tinha entrado pelo
 * `/store`.
 */
export function emptyCartKeepingContext(cart: ICart): ICart {
  return {
    ...defaultCart(),
    styleSale: cart.styleSale,
    channel: getCartChannel(cart),
  };
}

/** Reads the cart from sessionStorage, falling back to an empty cart. */
export function getCart(): ICart {
  const stored = sessionStorage.getItem(CART_KEY);
  return stored === null ? defaultCart() : JSON.parse(stored);
}

/** Persists the cart to sessionStorage (same key/shape unmigrated pages read) and returns it. */
export function saveCart(cart: ICart): ICart {
  sessionStorage.setItem(CART_KEY, JSON.stringify(cart));
  return cart;
}

/** Removes the cart from sessionStorage entirely. */
export function clearCart(): void {
  sessionStorage.removeItem(CART_KEY);
}
